import axios from 'axios'
import router from '../../router'

const state = {
  RegEstate: [],
  idEstate: ''
}

const getters = {
  getRegEstate (state) {
    return state.RegEstate
  },
  getidEstate (state) {
    return state.idEstate
  }
}

const mutations = {
  setRegEstate (state, payload) {
    state.RegEstate = payload
  },
  setidEstate (state, payload) {
    state.idEstate = payload
  }
}

const actions = {
  apiEstate (context, payload) {
    // if (payload.method === 'POST') {
    // } else if (payload.method === 'DELETE') {
    // } else { // GET method
    //   alert('11')
    if (payload.flag === 'SELECT') {
      axios.post('/api/estate/selectEstate', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setRegEstate', response.data)
        })
        .catch((error) => {
          alert(error.response.data.message)
        })
    } else if (payload.flag === 'MEMBERINSERT') {
      if (sessionStorage.getItem('token') != null) {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
        // console.log(payload)
        return new Promise((resolve, reject) => {
          axios.post('/api/member/insertEstate', payload)
            .then((response) => {
              // console.log(response)
              context.commit('setidEstate', response.data.idEstate)
              resolve(response)
            })
            .catch((error) => {
              reject(error.response.data.message)
              if (error.response.status === 403) {
                sessionStorage.removeItem('token')
                alert('세션 만료 또는 잘못된 접근 입니다.')
                router.push('/Login')
              }
            })
        })
      } else {
        alert('세션이 만료되었습니다.')
        router.push('/AdminLogin')
      }
    } else if (payload.flag === 'INSERT') {
      if (sessionStorage.getItem('token') != null) {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
        // console.log(payload)
        return new Promise((resolve, reject) => {
          axios.post('/api/admin/insertEstate', payload)
            .then((response) => {
              // console.log(response)
              context.commit('setidEstate', response.data.idEstate)
              resolve(response)
            })
            .catch((error) => {
              reject(error.response.data.message)
              if (error.response.status === 403) {
                sessionStorage.removeItem('token')
                alert('세션 만료 또는 잘못된 접근 입니다.')
                router.push('/AdminLogin')
              }
            })
        })
      } else {
        alert('세션이 만료되었습니다.')
        router.push('/AdminLogin')
      }
    } else if (payload.flag === 'UPDATE') {
      if (sessionStorage.getItem('token') != null) {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
        // console.log(payload)
        return new Promise((resolve, reject) => {
          axios.post('/api/admin/updateEstate', payload)
            .then((response) => {
              // console.log(response)
              context.commit('setidEstate', response.data.idEstate)
              resolve(response)
            })
            .catch((error) => {
              reject(error.response.data.message)
              if (error.response.status === 403) {
                sessionStorage.removeItem('token')
                alert('세션 만료 또는 잘못된 접근 입니다.')
                router.push('/AdminLogin')
              }
            })
        })
      } else {
        alert('세션이 만료되었습니다.')
        router.push('/AdminLogin')
      }
    }
    // }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/registration.js